import { Box, Typography, TextField, Button, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import GCBackButton from "../../components/GreenCity/GCBackButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { colors } from "../../common/colors";
import { convertHeicToJpeg, getFileExtenction } from "../../common/files";
import { imageAcceptedExtension, validateImage } from "../../common/images";
import ButtonOutlinedCentered from "../../components/ButtonOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CurrencyYenSharpIcon from "@mui/icons-material/CurrencyYenSharp";
import { styles } from "../styles";
import { useSelector } from "react-redux";
import SwitchComponent from "../../components/GreenCity/SwitchComponent";
import { useAppDispatch } from "../../redux/store";
import { setGroupInfo } from "../../redux/Reducers/gcGroupReducer";
import { isOver18YearsOld } from "../../util/utils";

const defaultImage = require("../../assets/images/default.png");
function CreateGroupStep2(): ReactElement {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const groupInfo = useSelector((state: any) => state.gcGroup);
  const { user } = useSelector((state: any) => state.userAuth);
  const [image, setImage] = useState<any>();
  const [mainImage, setMainImage] = useState<any>();
  const [mainImageFile, setMainImageFile] = useState<any>();
  const [desc, setDesc] = useState("");
  const [groupWebURLs, setGroupWebURLs] = useState("");
  const [approvalRequired, setApprovalRequired] = useState<any>("NO");
  const [isLimited, setIsLimited] = useState("No");
  const [memberShipFee, setMemberShipFee] = useState(false);
  const [memberShipFeeAmount, setMemberShipFeeAmount] = useState<number>(0);
  const [isPaid, setIsPaid] = useState<boolean>(false);
  const [paymentFrequency, setPaymentFrequency] = useState("MONTHLY");
  const [groupPaymentField, setGroupPaymentField] = useState<number>(0);
  const [paymentDesc, setPaymentDesc] = useState("");
  const [errors, setErrors] = useState({
    groupPaymentField: false,
    groupPaymentDescription: false,
    groupMemberShipFeeAmount: false,
    groupMainImage: ""
  });

  const [announcements, setAnnouncements] = useState({
    anotherField1: "",
    anotherField2: "",
    anotherField3: "",
    anotherField4: "",
    anotherField5: "",
  });

  useEffect(() => {
    if (groupInfo) {
      const icon = groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : defaultImage;
      setImage(icon); // Set the image URL

      if (groupInfo.groupMainImage) {
        if (groupInfo.groupMainImage instanceof File) {
          setMainImageFile(groupInfo.groupMainImage);
          setMainImage(URL.createObjectURL(groupInfo.groupMainImage));
        } else {
          setMainImage(defaultImage);
        }
        setErrors((prev) => ({ ...prev, groupMainImage: "" }));
      }
      setDesc(groupInfo?.groupDesc || "");
      setGroupWebURLs(groupInfo?.groupWebURLs || "");
      setApprovalRequired(groupInfo?.groupApprovalRequired ? "YES" : "NO");
      setIsLimited(groupInfo?.groupIsLimited ? "Yes" : "No");
      if (groupInfo?.groupMemberShipFeeAmount) setMemberShipFeeAmount(groupInfo?.groupMemberShipFeeAmount);
      setMemberShipFee(groupInfo?.groupMemberShipFeeAmount ? true : false);

      setIsPaid(!!groupInfo?.groupPaymentField);
      setPaymentFrequency(groupInfo?.isMonthly ? "MONTHLY" : "YEARLY");
      setGroupPaymentField(groupInfo?.groupPaymentField || 0);
      setPaymentDesc(groupInfo?.groupPaymentDescription || "");
      const updatedData = {
        anotherField1: groupInfo.groupAnnouncements[0].value,
        anotherField2: groupInfo.groupAnnouncements[1].value,
        anotherField3: groupInfo.groupAnnouncements[2].value,
        anotherField4: groupInfo.groupAnnouncements[3].value,
        anotherField5: groupInfo.groupAnnouncements[4].value,
      };

      setAnnouncements(
        updatedData // Override with new values
      );
    }
  }, [groupInfo]);

  // Handle change for each field
  const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setAnnouncements((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };
  const handlePaymentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPaymentFrequency((event.target as HTMLInputElement).value);
  };
  const handlePPChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //public private
    setApprovalRequired((event.target as HTMLInputElement).value);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  const handleSave = () => {
    if (memberShipFee && !memberShipFeeAmount) {
      setErrors((prev) => ({ ...prev, groupMemberShipFeeAmount: true }));
      return;
    }
    if (isPaid && !groupPaymentField) {
      setErrors((prev) => ({ ...prev, groupPaymentField: true }));
      return;
    }
    // Dispatch action to save group details
    const groupAttributes = {
      groupMainImage: mainImageFile, // From state
      groupDesc: desc, // From state
      groupAnnouncements: [
        { value: announcements.anotherField1 },
        { value: announcements.anotherField2 },
        { value: announcements.anotherField3 },
        { value: announcements.anotherField4 },
        { value: announcements.anotherField5 },
      ], // From state
      groupWebURLs: groupWebURLs, // You can replace this with the actual value
      groupApprovalRequired: approvalRequired === "YES",
      groupIsLimited: isLimited === "YES",
      groupMemberShipFeeAmount: memberShipFee ? memberShipFeeAmount : null,
      isMonthly: paymentFrequency === "MONTHLY", // Static value
      groupPaymentField: isPaid ? groupPaymentField : null,
      groupPaymentDescription: paymentDesc,
    }

    dispatch(setGroupInfo(groupAttributes))

    const groupProps = {
      ...groupInfo,
      ...groupAttributes
    }
    navigate("/groupinforeview", {state: { groupProps: groupProps }});
  };

  const fileInputRef = useRef<any>();

  const handleButtonClick = () => {
    fileInputRef?.current.click();
  };

  const handleFileChange = async (event: any) => {
    let file = event.target.files[0];
    if (!file) {
      console.error("ファイルを取得できませんでした。", event)
      return
    }

    const errMsg = validateImage(file)
    if (errMsg) {
      setErrors((prev) => ({ ...prev, groupMainImage: errMsg }));
      return
    }

    if (getFileExtenction(file) === "heic") {
      try {
        file = await convertHeicToJpeg(file);
      } catch (e: any) {
        console.error(e);
        return
      }
    }
    setMainImageFile(file);
    const imageUrl = URL.createObjectURL(file); // Generate URL from the file
    setMainImage(imageUrl); // Set the image URL
    setErrors((prev) => ({ ...prev, groupMainImage: "" }));
  };

  const handleChangeMemberShipFeeAmount = (e: any) => {
    const value = e.target.value
    if (Number.isNaN(Number(value))) return
    setMemberShipFeeAmount(Number(value))
  }

  const handleChangeGroupPaymentField = (e: any) => {
    const value = e.target.value
    if (Number.isNaN(Number(value))) return
    setGroupPaymentField(Number(value))
  }

  return (
    <div style={{ paddingTop: 100, height: "100vh" }}>
      <Box>
        <GCBackButton onClick={() => navigate(-1)} />
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 16,
            borderBottomColor: colors.farm_gray15,
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <img
              alt=""
              style={{
                height: 32,
                width: 32,
                borderRadius: 18,
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: colors.farm_green500,
              }}
              src={image || defaultImage}
            />
            <Typography style={{ fontSize: 14, fontWeight: 600 }}>&nbsp;{groupInfo.groupName}</Typography>
          </div>

          {/* <Typography>EDIT</Typography> */}
        </Box>
        <Box style={{}}>
          <Typography
            style={{
              borderBottomColor: colors.farm_green150,
              borderBottomWidth: 2,
              borderBottomStyle: "solid",
              fontSize: 14,
              marginBottom: 6,
              marginTop: 16,
              marginLeft: 16,
              marginRight: 16,
            }}
          >
            {T("create_group_main_image")}
          </Typography>
          {errors.groupMainImage && <Typography sx={{ color: colors.farm_red600 }}>{errors.groupMainImage}</Typography>}
          <img
            alt=""
            style={{
              height: 220,
              width: "90%",
              alignSelf: "center",
              margin: "auto",
              display: "flex",
            }}
            src={mainImage || defaultImage}
          />
          <div>
            <ButtonOutlinedCentered title={T("create_group_select_image")} onClick={handleButtonClick} pLR={6} />
            <input
              type="file"
              accept={imageAcceptedExtension}
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }} // Hide the file input
            />
          </div>
          <Box style={{ padding: 16 }}>
            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                fontSize: 14,
                marginBottom: 6,
              }}
            >
              &nbsp;{T("create_group_description")}
            </Typography>
            <TextField
              value={desc}
              sx={{ justifyContent: "start", width: "100%" }}
              hiddenLabel
              multiline
              rows={7}
              // inputProps={{ maxLength: MAX_LENGTH }}
              onChange={(e) => {
                setDesc(e.target.value)
              }}
            />
            <Box>
              <Typography
                style={{
                  borderBottomColor: colors.farm_green150,
                  borderBottomWidth: 2,
                  borderBottomStyle: "solid",
                  fontSize: 14,
                  marginBottom: 6,
                  marginTop: 16,
                }}
              >
                <CampaignOutlinedIcon style={{ transform: "rotate(-30deg)" }} />
                &nbsp;{T("group_content")}
              </Typography>
              <TextField
                fullWidth
                hiddenLabel
                id="outlined-basic"
                variant="outlined"
                value={announcements.anotherField1}
                onChange={handleChange("anotherField1")}
                InputProps={{
                  style: {
                    height: 40, // Set your desired height here
                    padding: "4px 8px", // Adjust padding to fit your design
                  },
                }}
                style={{ marginTop: 6 }} // Keep margin top if needed
              />
              <TextField
                fullWidth
                hiddenLabel
                id="outlined-basic"
                variant="outlined"
                value={announcements.anotherField2}
                onChange={handleChange("anotherField2")}
                InputProps={{
                  style: {
                    height: 40, // Set your desired height here
                    padding: "4px 8px", // Adjust padding to fit your design
                  },
                }}
                style={{ marginTop: 6 }} // Keep margin top if needed
              />

              <TextField
                fullWidth
                hiddenLabel
                id="outlined-basic"
                variant="outlined"
                value={announcements.anotherField3}
                onChange={handleChange("anotherField3")}
                InputProps={{
                  style: {
                    height: 40, // Set your desired height here
                    padding: "4px 8px", // Adjust padding to fit your design
                  },
                }}
                style={{ marginTop: 6 }} // Keep margin top if needed
              />
              <TextField
                fullWidth
                hiddenLabel
                id="outlined-basic"
                variant="outlined"
                value={announcements.anotherField4}
                onChange={handleChange("anotherField4")}
                InputProps={{
                  style: {
                    height: 40, // Set your desired height here
                    padding: "4px 8px", // Adjust padding to fit your design
                  },
                }}
                style={{ marginTop: 6 }} // Keep margin top if needed
              />
              <TextField
                fullWidth
                hiddenLabel
                id="outlined-basic"
                variant="outlined"
                value={announcements.anotherField5}
                onChange={handleChange("anotherField5")}
                InputProps={{
                  style: {
                    height: 40, // Set your desired height here
                    padding: "4px 8px", // Adjust padding to fit your design
                  },
                }}
                style={{ marginTop: 6 }} // Keep margin top if needed
              />
            </Box>
            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                fontSize: 14,
                marginBottom: 6,
                marginTop: 16,
              }}
            >
              {T("group_url")}
            </Typography>
            <TextField
              value={groupWebURLs}
              sx={{ justifyContent: "start", width: "100%" }}
              hiddenLabel
              multiline
              rows={7}
              onChange={(e) => {
                setGroupWebURLs(e.target.value)
              }}
            />

            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                fontSize: 14,
                marginBottom: 6,
                marginTop: 16,
              }}
            >
              <PeopleAltOutlinedIcon />
              &nbsp;{T("joining_description")}
            </Typography>

            <>
              {groupInfo?.groupIsPublic ? (
                <RadioGroup aria-labelledby="payment-radio-buttons-group-label" value={approvalRequired} onChange={handlePPChange} name="radio-buttons-group">
                  <FormControlLabel
                    value="NO"
                    control={<Radio sx={{ alignSelf: "flex-start" }} />} // Aligns the radio button to the top
                    label={
                      <div>
                        <Typography variant="body1">{T("joining_description_anyone")}</Typography>

                        <Typography variant="body2" color="textSecondary">
                          {T("create_group_entry_anyone_description")}
                        </Typography>
                        <br />
                      </div>
                    }
                    sx={{ alignItems: "flex-start" }} // Aligns the whole label to the top
                  />
                  <FormControlLabel
                    value="YES"
                    control={<Radio sx={{ alignSelf: "flex-start" }} />}
                    label={
                      <div>
                        <Typography variant="body1">{T("joining_description_approval")}</Typography>

                        <Typography variant="body2" color="textSecondary">
                          {T("create_group_entry_approval_required_description")}
                        </Typography>
                      </div>
                    }
                    sx={{ alignItems: "flex-start" }}
                  />
                </RadioGroup>
              ) : (
                <RadioGroup aria-labelledby="payment-radio-buttons-group-label" value={approvalRequired} onChange={handlePPChange} name="radio-buttons-group">
                  <FormControlLabel
                    value="NO"
                    control={<Radio sx={{ alignSelf: "flex-start" }} />} // Aligns the radio button to the top
                    label={
                      <div>
                        <Typography variant="body1">{T("joining_description_invitation")}</Typography>

                        <Typography variant="body2" color="textSecondary">
                          {T("create_group_entry_invitation_required_description")}
                        </Typography>
                        <br />
                      </div>
                    }
                    sx={{ alignItems: "flex-start" }} // Aligns the whole label to the top
                  />
                </RadioGroup>
              )}
            </>

            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                fontSize: 14,
                marginBottom: 6,
                marginTop: 16,
                color: isOver18YearsOld(user.dob) ? "inherit" : "#a2a2a2"
              }}
            >
              <CurrencyYenSharpIcon
                style={{
                  borderWidth: 1,
                  borderStyle: "solid",
                  width: 30,
                  height: 30,
                  borderRadius: 15,
                  padding: 2,
                  margin: 2,
                  color: isOver18YearsOld(user.dob) ? "inherit" : "#a2a2a2"
                }}
              />
              &nbsp;{T("fee_description")}
            </Typography>
            <SwitchComponent
              title={T("create_group_joining_fee_title")}
              desc={T("create_group_joining_fee_description")}
              checked={memberShipFee}
              onChange={(checked) => {
                setMemberShipFee(checked);
              }}
              disabled={!isOver18YearsOld(user.dob)}
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
              }}
            >
              <TextField
                hiddenLabel
                id="outlined-basic"
                variant="outlined"
                error={errors.groupMemberShipFeeAmount}
                helperText={errors.groupMemberShipFeeAmount ? T("create_group_lack_of_required_item") : ""}
                disabled={!memberShipFee}
                type="text"
                value={memberShipFeeAmount}
                onChange={(e: any) => {
                  handleChangeMemberShipFeeAmount(e);
                  setErrors({ ...errors, groupMemberShipFeeAmount: false });
                }}
                InputProps={{
                  style: {
                    height: 40, // Set your desired height here
                    padding: "4px 8px", // Adjust padding to fit your design
                    color: isOver18YearsOld(user.dob) ? "inherit" : "#a2a2a2"
                  },
                }}
                style={{ marginTop: 6 }} // Keep margin top if needed
              />
              <Typography style={{ color: isOver18YearsOld(user.dob) ? "inherit" : "#a2a2a2" }} >
                {T("unit_yen")}
              </Typography>
            </Box>

            <SwitchComponent
              title={T("create_group_regular_fee_title")}
              desc={T("create_group_regular_fee_description")}
              checked={isPaid}
              onChange={(checked) => setIsPaid(checked)}
              disabled={!isOver18YearsOld(user.dob)}
            />
            <br />
            {isPaid && (
              <>
                <Typography
                  style={{
                    fontSize: 14,
                    marginBottom: 6,
                  }}
                >
                  &nbsp;{T("create_group_fee_set_amount")}
                </Typography>
                <RadioGroup aria-labelledby="payment-radio-buttons-group-label" value={paymentFrequency} onChange={handlePaymentChange} name="radio-buttons-group">
                  <FormControlLabel
                    value="MONTHLY"
                    control={<Radio />}
                    label={T("monthly_fee")} // 月会費
                  />
                  <FormControlLabel
                    value="YEARLY"
                    control={<Radio />}
                    label={T("yearly_fee")} // 年会費
                  />
                </RadioGroup>
                <Typography style={{ fontSize: 12, color: colors.farm_gray200 }}>{T("create_group_fee_method_to_pay")}</Typography>
                <Typography style={{ fontSize: 12, color: colors.farm_gray200 }}>{T("create_group_fee_notice")}</Typography>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    marginBottom: 24,
                  }}
                >
                  <TextField
                    hiddenLabel
                    id="outlined-basic"
                    variant="outlined"
                    value={groupPaymentField}
                    error={errors.groupPaymentField}
                    helperText={errors.groupPaymentField ? T("create_group_lack_of_required_item") : ""}
                    onChange={(e: any) => {
                      handleChangeGroupPaymentField(e);
                      setErrors({ ...errors, groupPaymentField: false });
                    }}
                    InputProps={{
                      style: {
                        height: 40, // Set your desired height here
                        padding: "4px 8px", // Adjust padding to fit your design
                      },
                    }}
                    style={{ marginTop: 6 }} // Keep margin top if needed
                  />
                  <Typography>{T("unit_yen")}</Typography>
                </Box>
                <Typography
                  style={{
                    fontSize: 14,
                    marginBottom: 6,
                  }}
                >
                  &nbsp;{T("create_group_fee_payment_description")}
                </Typography>
                <TextField
                  // error={descError}
                  value={paymentDesc}
                  // helperText={descError ? "* fields are required.." : ""}
                  sx={{ justifyContent: "start", width: "100%" }}
                  hiddenLabel
                  multiline
                  rows={7}
                  // inputProps={{ maxLength: MAX_LENGTH }}
                  onChange={(e) => {
                    setPaymentDesc(e.target.value);
                    // if (desc.length > 0) {
                    //   setDescError(false);
                    // }
                  }}
                />
              </>
            )}

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={() => {
                  handleSave();
                }}
                style={{
                  ...styles.introSliderBtn,
                  marginTop: 40,
                  width: 220,
                }}
                size={"large"}
                variant="contained"
                endIcon={<ArrowForwardIosIcon />}
              >
                <span style={{ paddingRight: 30, paddingLeft: 40 }}>{T("check")}</span>
              </Button>
              <Box style={{ height: 100 }}></Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default CreateGroupStep2;
